import { useContext } from "react";
import { Box, IconButton, Typography, useMediaQuery } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { LayoutContext } from "../../context/LayoutContext";

export default function SidebarHeader({ overlay, isSettings }) {
  const { collapsed, setCollapsed, setMobileOpen } = useContext(LayoutContext);
  const isOverlayDevice = useMediaQuery("(max-width:999px)");

  const toggle = () => {
    if (overlay) setMobileOpen(false);
    else if (isOverlayDevice) setMobileOpen(true);
    else setCollapsed(!collapsed);
  };

  return (
    <Box
      sx={{
        p: 3,
        display: "flex",
        justifyContent: collapsed && !overlay ? "center" : "space-between",
        alignItems: "center",
        borderBottom: "1px solid rgba(255,255,255,0.1)",
      }}
    >
      {(!collapsed || overlay) && (
        <Typography fontSize={22} fontWeight={800}>
          {isSettings ? "Settings" : "CRM"}
        </Typography>
      )}

      <IconButton sx={{ color: "#fff" }} onClick={toggle}>
        {overlay ? <CloseIcon /> : <MenuIcon />}
      </IconButton>
    </Box>
  );
}
